// src/App.js
import "../src/assets/styles/global.css";
import { Route, Routes } from 'react-router-dom';
import EPSSCalculator from './pages/EPSSCalculator';
import Reports from "./components/Reports";
import HeaderContainer from "./components/HeaderContainer";
import Footer from "./components/Footer";
// import FirebaseUIComponent from "./FirebaseUIComponent";

// Import Firebase initialization
// import './firebase'; // Make sure this is imported before using FirebaseUIComponent

function App() {
  return (
    <>
      <HeaderContainer />
      <Routes>
        <Route path="/" element={<EPSSCalculator />} />
        <Route path="/reports" element={<Reports />} />
        {/* <Route path="/login" element={<FirebaseUIComponent />} /> */}
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
